var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticClass:"container"},[_c('div',{staticClass:"el-header"},[_c('Head')],1),_c('div',{staticClass:"topHeight"}),_c('el-main',[_c('Main',{staticClass:"main-cont"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }